import { createSlice } from '@reduxjs/toolkit';
import { createSessionAsync, createSessionAsyncBuilder, removeSessionAsync, removeSessionAsyncBuilder, } from './asyncRequests';
const initialState = {
    data: {},
    loading: false,
    success: false,
    error: '',
};
export const AuthSlice = createSlice({
    name: 'authSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        createSessionAsyncBuilder(builder);
        removeSessionAsyncBuilder(builder);
    },
});
export const AuthActions = {
    ...AuthSlice.actions,
    createSessionAsync,
    removeSessionAsync,
};
export const AuthReducer = AuthSlice.reducer;
